<template>
  <div class="h-dialogContainer h-track-tabPage">
    <div class="row"></div>
    <form id="instanceServiceProfileForm">
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('NSMF.instanceName')}} :</div>
          <ejs-textbox name="nameCheck" v-model="name"></ejs-textbox>
        </div>

        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('NSMF.sst')}} :</div>
          <ejs-dropdownlist
            :dataSource="sstList"
            v-model="sst"
            name="sstCheck"
            :fields="fieldsOfSST"
            @change="changeForStatus"
          ></ejs-dropdownlist>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('NSMF.sd')}} :</div>
          <ejs-textbox name="sdCheck" v-model="sd"></ejs-textbox>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('NSMF.mcc')}} :</div>
          <ejs-textbox name="mccCheck" v-model="mcc"></ejs-textbox>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('NSMF.mnc')}} :</div>
          <ejs-textbox name="mncCheck" v-model="mnc"></ejs-textbox>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('NSMF.maxNumberofUEs')}} :</div>
          <!-- <ejs-dropdownlist
            :dataSource="maxNumberofUEsList"
            v-model="maxNumberofUEs"
            name="maxNumberofUEsCheck"
            :fields="fieldsOfMaxNumberofUEs"
            @change="changeForUEs"
          ></ejs-dropdownlist> -->
          <ejs-textbox name="maxNumberofUEsCheck" v-model="maxNumberofUEs"></ejs-textbox>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('NSMF.caps')}} :</div>
          <!-- <ejs-dropdownlist
            :dataSource="capsList"
            v-model="caps"
            name="capsCheck"
            :fields="fieldsOfCaps"
            @change="changeForCaps"
          ></ejs-dropdownlist> -->
          <ejs-textbox name="capsCheck" v-model="caps"></ejs-textbox>
        </div>

        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('NSMF.gbps')}} :</div>
          <!-- <ejs-dropdownlist
            :dataSource="gbpsList"
            v-model="gbps"
            name="gbpsCheck"
            :fields="fieldsOfGbps"
            @change="changeForGbps"
          ></ejs-dropdownlist> -->
          <ejs-textbox name="gbpsCheck" v-model="gbps"></ejs-textbox>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('NSMF.gnbNum')}} :</div>
          <ejs-textbox name="gnbNumCheck" v-model="gnbNum"></ejs-textbox>
        </div>
       </div>
    </form>
  </div>
</template>
<script>
import { EventBus } from "../../../plugins/eventBus";
import { FormValidator } from "@syncfusion/ej2-vue-inputs";

export default {
  name: "AddServiceProfile",
  components: {},
  data() {
    return {
      sst: "",
      sd: "",
      mcc: "",
      mnc: "",
      maxNumberofUEs: "",
      caps: "",
      gbps: "",
      gnbNum: "",
      name: "",
      fieldsOfSST: {
        text: "text",
        value: "value"
      },
      sstList: [
        { text: "eMBB", value: "1" },
        { text: "URLLC", value: "2" },
        { text: "MIoT", value: "3" },
        { text: "V2X", value: "4" }
      ],
      // fieldsOfMaxNumberofUEs: {
      //   text: "text",
      //   value: "value"
      // },
      // maxNumberofUEsList: [{ text: "100000", value: "100000" }],
      // fieldsOfCaps: {
      //   text: "text",
      //   value: "value"
      // },
      // capsList: [{ text: "200", value: "200" }],
      // fieldsOfGbps: {
      //   text: "text",
      //   value: "value"
      // },
      // gbpsList: [{ text: "20", value: "20" }],
      locale: localStorage.getItem("locale"),

      formObj: "",
      validationOption: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.float = "left";
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          nameCheck: {
            required: [true, `${this.$t("Pm.alertRequired")}`],
            regex: [/^(^\S)/, `${this.$t("Topo.noEmptyStart")}`],
            maxLength: [30, `${this.$t("Topo.topoMaxLength")}30`]
          },
          sstCheck: {
            required: [true, `${this.$t("Pm.alertRequired")}`]
          },
          sdCheck: {
            required: [true, `${this.$t("Pm.alertRequired")}`],
            regex: ["^\\d*$", `${this.$t("Topo.invalidInt")}`],
            range: [[1, 16777215], `${this.$t('NSMF.inputRangeIllegal')}`],            
          },
          mccCheck: {
            required: [true, `${this.$t("Pm.alertRequired")}`],
            regex: ["^\\d*$", `${this.$t("Topo.invalidInt")}`],
            minLength: [3, `${this.$t("Software.RequiredLength")} 3`],
            maxLength: [3, `${this.$t("Software.RequiredLength")} 3`]
          },
          mncCheck: {
            required: [true, `${this.$t("Pm.alertRequired")}`],
            regex: ["^\\d*$", `${this.$t("Topo.invalidInt")}`],
            minLength: [2, `${this.$t("Common.minLength")} 2`],
            maxLength: [3, `${this.$t("Common.maxLength")} 3`]
          },
          maxNumberofUEsCheck: {
            regex: ["^\\d*$", `${this.$t("Topo.invalidInt")}`],
            range: [[1, 10000], `${this.$t('NSMF.numberRangeIllegal')}`],
          },
          capsCheck: {
            regex: ["^\\d*$", `${this.$t("Topo.invalidInt")}`],
            range: [[1, 20000], `${this.$t('NSMF.capsRangeIllegal')}`],
          },
          gbpsCheck: {
            regex: ["^\\d*$", `${this.$t("Topo.invalidInt")}`],
            range: [[1, 20], `${this.$t('NSMF.gbpsRangeIllegal')}`]

          },
          gnbNumCheck: {
            regex: ["^\\d*$", `${this.$t("Topo.invalidInt")}`],
            range: [[1, 128], `${this.$t('NSMF.gnbNumRangeIllegal')}`],
          },
        }
      }
    };
  },
  methods: {
    changeForStatus(msg) {
      this.sst = msg.value;
    },
    // changeForUEs(msg) {
    //   this.maxNumberofUEs = msg.value;
    // },
    // changeForCaps(msg) {
    //   this.caps = msg.value;
    // },
    // changeForGbps(msg) {
    //   this.gbps = msg.value;
    // },
    clear() {
      this.mcc = "";
      this.sd = "";
      this.sst = "";
      this.mnc = "";
      this.name = "";
      this.maxNumberofUEs = "";
      this.gnbNum = "";
      this.caps = "";
      this.gbps = "";
    },

    init(checkedData) {
      console.log("checkedData=====", checkedData);
      this.mcc = checkedData.pLMNList.split(":")[0];
      this.sd = checkedData.sNSSAIList.split(":")[1];
      this.mnc = checkedData.pLMNList.split(":")[1];
      // this.name = checkedData.name;不填写目的是让用户把实例名称和模板名称区分
      this.maxNumberofUEs = checkedData.maxNumberOfUEs;
      this.caps = checkedData.caps;
      this.gbps = checkedData.throughPut;
      this.sst = checkedData.sST;
      this.gnbNum = checkedData.numberOfStation;

      try {
        this.bindValidate();
      } catch (e) {
        console.log(e);
      }
    },
    getInstanceBase() {
      if (!this.validate()) {
        return false;
      }

      return {
        sNSSAIList: this.sst + ":" + this.sd,
        sST: this.sst,
        pLMNList: this.mcc + ":" + this.mnc,
        maxNumberOfUEs: this.maxNumberofUEs==""?2:this.maxNumberofUEs,
        caps: this.caps==""?2:this.caps,
        throughPut: this.gbps==""?1:this.gbps,
        numberOfStation: this.gnbNum==""?1:this.gnbNum,
        name: this.name
      };
    },
    bindValidate() {
      this.formObj = new FormValidator(
        "#instanceServiceProfileForm",
        this.validationOption
      );
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    }
  },
  mounted() {
    this.bindValidate();
  }
};
</script>
